import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./languages/en.json";
import tr from "./languages/tr.json";
import pl from "./languages/pl.json";

const savedLanguage = localStorage.getItem("language") || "pl";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    tr: { translation: tr },
    pl: { translation: pl },
  },
  fallbackLng: "pl",
  lng: savedLanguage,
  interpolation: { escapeValue: false },
  debug: false,
  react: {
    useSuspense: false,
  },
});

export default i18n;
